import v100 from 'src/components/forms/schemas/eventResult/notes/1.0.0';

export default {
  '1.0.0': v100,
  latest: v100,
};
